<template>

  <div class="card club-card">
    <div class="card-body">
      <div class="d-flex">
        <div class="p-2 w-100">
          <div class="club-profile-pic">
            <img :src="$imagePathBase + 'default-club-pic.png'" :height=50 class="profile-pic" referrerPolicy="no-referrer">
<!--            <img :src="$imagePathBase + 'club-plus.png'" :height=20 class="plus-sign" referrerPolicy="no-referrer">-->
            <i class="fa fa-qrcode" aria-hidden="true"></i>
          </div>
          <div class="join-club-text">
            <span class="title-text">Join an Oscar pool</span><br>
            <span class="details-text">Join an existing Oscar Pool by asking a member to share their invite link.</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>


<script>
export default {
  name: 'ClubCard_JoinClub',
  components: {},
  computed: {
  },
  data() {
    return {
    }
  },
  watch: {

  },
  methods: {

  }
}
</script>


<style scoped>

.club-card {
  isolation: isolate;
  overflow: hidden;

  text-decoration: inherit;

  border-style: none;
  border-width: 2px;
  /*
  background-color: var(--mol-color-gold-background);
  border-color: var(--mol-color-gold);
  */
  color: var(--mol-color-gold-text);
  margin: 18px;
}

.join-club-text {
  display: inline-block;
  width: calc(100% - 70px);

  .title-text {
    margin-left: -15px;
    font-size: 1.3rem;
    font-weight: 500;
  }
  .details-text {
    display: inline-block;
  }
}


.club-profile-pic {
  display: inline-block;
  vertical-align: top;

  .profile-pic {
    position: relative;
    border-radius: 20%;
    border-style: solid;
    border-width: 0.1px;
    border-color: lightgrey;
  }
  .fa-qrcode {
    position: relative;
    font-size: 25px;
    left: -15px;
    bottom: -22px;
  }
}




</style>